var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24,0V24H0V0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.75 2.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,2.06V0",
    transform: "translate(4.11)",
    fill: "none",
    stroke: "#8361DF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    strokeDasharray: "0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,2.06V0",
    transform: "translate(14.39)",
    fill: "none",
    stroke: "#8361DF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    strokeDasharray: "0 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    "data-name": "Group",
    transform: "translate(0 1.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M3.2,0A3.2,3.2,0,0,0,0,3.2V14.28a3.2,3.2,0,0,0,3.2,3.2H15.31a3.2,3.2,0,0,0,3.2-3.2V3.2A3.212,3.212,0,0,0,15.3,0Z",
    fill: "none",
    stroke: "#8361DF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    strokeDasharray: "0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H18.5",
    transform: "translate(0 4.12)",
    fill: "none",
    stroke: "#8361DF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    strokeDasharray: "0 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    "data-name": "Group",
    transform: "translate(14.25 7.25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8361DF",
    id: "Vector-6",
    "data-name": "Vector",
    d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    "data-name": "Group",
    transform: "translate(10.25 7.25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8361DF",
    id: "Vector-7",
    "data-name": "Vector",
    d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    "data-name": "Group",
    transform: "translate(6.25 7.25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8361DF",
    id: "Vector-8",
    "data-name": "Vector",
    d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    "data-name": "Group",
    transform: "translate(2.25 7.25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8361DF",
    id: "Vector-9",
    "data-name": "Vector",
    d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    "data-name": "Group",
    transform: "translate(14.25 10.74)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8361DF",
    id: "Vector-10",
    "data-name": "Vector",
    d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    "data-name": "Group",
    transform: "translate(10.25 10.74)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8361DF",
    id: "Vector-11",
    "data-name": "Vector",
    d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    "data-name": "Group",
    transform: "translate(6.25 10.74)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8361DF",
    id: "Vector-12",
    "data-name": "Vector",
    d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    "data-name": "Group",
    transform: "translate(2.25 10.74)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8361DF",
    id: "Vector-13",
    "data-name": "Vector",
    d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    "data-name": "Group",
    transform: "translate(10.25 14.22)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8361DF",
    id: "Vector-14",
    "data-name": "Vector",
    d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    "data-name": "Group",
    transform: "translate(6.25 14.22)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8361DF",
    id: "Vector-15",
    "data-name": "Vector",
    d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    "data-name": "Group",
    transform: "translate(2.25 14.22)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8361DF",
    id: "Vector-16",
    "data-name": "Vector",
    d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/Event.fedb0c4a73553c105666d347b2a95d27.svg";
export { ForwardRef as ReactComponent };